'use strict';
import actionTypes from '../actionTypes';

const initialState = {
    unreadCount: 0
};

function inboxReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_UNREAD_COUNT: {
            return Object.assign({}, state, {
                unreadCount: action.unreadCount
            });
        }
        default:
            return state;
    }
}

export { inboxReducer };

export default {
    inboxReducer: inboxReducer
};
